import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate
import {localizeKey, localizeArt} from './../localize.js';
import MyUserContext from './../myUserContext.js';
import PlatformRatings from './PlatformRatings';
// import ArtTabs from './ArtTabs';
import ArtThumbnail from './ArtThumbnail'; // Import ArtThumbnail

const CATEGORY_ENUM = {
  1: "movie",
  2: "videoGame",
  3: "book"
};

const ImageScroller = ({ arts }) => {
  const myUser = useContext(MyUserContext);
  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  const categories = ["movie", "book", "videoGame"];

  return (
    <div className="space-y-5">
      {categories.map((cat) => {
        const filteredArts = arts.filter(
          (item) => CATEGORY_ENUM[item.category] === cat
        );

        if (filteredArts.length === 0) return null;

        return (
          <div key={cat}>
            {/* Category title */}
            <div className="flex justify-center font-semibold capitalize mt-3">
              {cat === "movie"
                ? (language === "ru" ? "Фильмы" : "Movies")
                : cat === "book"
                ? (language === "ru" ? "Книги" : "Books")
                : (language === "ru" ? "Игры" : "Video Games")}
            </div>

            {/* Horizontal scroller */}
            <div
              className="flex overflow-x-auto whitespace-nowrap items-center py-2"
              style={{ scrollbarWidth: "none" }}
            >
              {filteredArts.map((item, index) => (
                <div key={index + item.id} className="inline-block mx-2">
                  <Link to={`/arts/${item.id}`}>
                    <ArtThumbnail art={item} />
                    <div className="w-32 flex justify-center text-center">
                      <div className="w-32 truncate text-xs">
                        {localizeArt(item, language).name}
                      </div>
                    </div>
                  </Link>
                  <PlatformRatings art={item} />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageScroller;
